<template>
  <article class="about-team-page">
    <h1>{{ category.title }}</h1>
    <section class="vadim-kachan-section">
      <about-team-vadim-summary
        v-bind:vadim-portrait-image="vadimPortraitImage"
      ></about-team-vadim-summary>
      <section class="vadim-smallest-ring-section">
        <about-team-vadim-smallest-ring
          v-bind:smallest-ring-images="smallestRingImages"
        ></about-team-vadim-smallest-ring>
        <about-team-vadim-interviews
          v-bind:smallest-ring-newspaper-images="smallestRingNewspaperImages"
        ></about-team-vadim-interviews>
      </section>
      <about-team-vadim-magazines
        v-bind:stylegold-with-koldun-image="styleGoldWithKoldunImage"
        v-bind:baltic-way-magazine-images="balticWayMagazineImages"
        v-bind:pan-arab-magazine-images="panArabMagazineImages"
      ></about-team-vadim-magazines>
    </section>
  </article>
</template>

<script>
import AboutTeamVadimInterviews from '../components/the-content/AboutTeamVadimInterviews'
import AboutTeamVadimMagazines from '../components/the-content/AboutTeamVadimMagazines'
import AboutTeamVadimSmallestRing from '../components/the-content/AboutTeamVadimSmallestRing'
import AboutTeamVadimSummary from '../components/the-content/AboutTeamVadimSummary'
import utils from './utils'

export default {
  name: 'AboutTeamPage',
  components: {
    AboutTeamVadimInterviews,
    AboutTeamVadimMagazines,
    AboutTeamVadimSmallestRing,
    AboutTeamVadimSummary
  },
  data: function () {
    return {
      category: {},
      vadimPortraitImage: {},
      smallestRingImages: [],
      smallestRingNewspaperImages: [],
      styleGoldWithKoldunImage: {},
      balticWayMagazineImages: [],
      panArabMagazineImages: [],
      title: 'Персоналии'
    }
  },
  metaInfo () {
    return {
      title: this.title,
      meta: utils.getDefaultMetaTags({
        description: this.category.meta_description,
        path: this.$router.resolve(this.$route).href,
        title: this.title,
        imageUrl: this.styleGoldWithKoldunImage.image,
        imageWidth: this.styleGoldWithKoldunImage.width,
        imageHeight: this.styleGoldWithKoldunImage.height
      })
    }
  },
  mounted () {
    this.getCategory()
    this.getImagesAboutTeam()
  },
  updated () {
    if (Object.keys(this.category).length > 0 &&
        Object.keys(this.vadimPortraitImage).length > 0 &&
        this.smallestRingImages.length > 0 &&
        this.smallestRingNewspaperImages.length > 0 &&
        Object.keys(this.styleGoldWithKoldunImage).length > 0 &&
        this.balticWayMagazineImages.length > 0 &&
        this.panArabMagazineImages.length > 0 &&
        window['__PRERENDER_INJECTED']
    ) {
      document.dispatchEvent(new Event('render-event'))
    }
  },
  methods: {
    getCategory: function () {
      this.$http
        .get(`${process.env.API_HOST}/api/v1/site-structure/get-category/team`)
        .then(response => { this.category = response.body })
    },
    getImagesAboutTeam: function () {
      const uri = `${process.env.API_HOST}/api/v1/images/get-images-by-tags`
      const repairTags = ['about-page', 'about-team']
      let uriParams = {include_tags: repairTags.join(',')}

      this.$http
        .get(uri, {params: uriParams})
        .then(response => {
          let allImages = response.body

          this.vadimPortraitImage = allImages.find(
            this.tagIncludeCallback('vadim-portrait'))
          this.styleGoldWithKoldunImage = allImages.find(
            this.tagIncludeCallback('koldun'))

          this.balticWayMagazineImages = allImages.filter(
            this.tagIncludeCallback('baltic-way'))
          this.panArabMagazineImages = allImages.filter(
            this.tagIncludeCallback('pan-arab'))

          let ringImages = allImages.filter(
            this.tagIncludeCallback('smallest-ring'))

          this.smallestRingNewspaperImages = ringImages.filter(
            this.tagIncludeCallback('newspaper'))
          this.smallestRingImages = ringImages.filter(
            this.tagExcludeCallback('newspaper'))
        })
    },
    tagIncludeCallback: function (tag) {
      return function (image) { return image.tags.includes(tag) }
    },
    tagExcludeCallback: function (tag) {
      return function (image) { return !image.tags.includes(tag) }
    }
  }
}
</script>

<style scoped lang="scss">
  .about-team-page {
    background-color: $default-background-color;
    @include media (">desktop") { padding-top: 3em; };
    @include media ("<=desktop") { padding-top: 2em; };
    @media only print { padding-top: 0; }
    h1 {
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/AboutTeamPage.vue